export default "__VITE_ASSET__0f2e0693__"